import styled from "styled-components";

export const PageBackground = styled.div`
  width: 100%;
  background: #f3f5f8;
`;

export const PageContainer = styled.div`
  width: 100%;
  max-width: 1440px;
  margin: 0 auto;
  padding: 24px 32px;
  display: flex;
  flex-direction: column;
  @media (max-width: 520px) {
    padding: 24px 16px;
  }
`;
